import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { LocalService, ManagerService } from '../../../../core';
import { PopupMessageService } from '../../../../shared/message/services/message.service';
import { StoreService } from '../../../../core/services/store.service';

@Component({
  selector: 'app-seller-preferences-management',
  templateUrl: './seller-preferences-management.component.html',
  styleUrls: ['./seller-preferences-management.component.scss']
})
export class SellerPreferencesManagementComponent implements OnInit {
  @Input() companyTypePreferences: any = [];
  @Input() isChallengePreference!: boolean;
  @Input() userProfile: any;
  @Output() preferenceChanged = new EventEmitter<void>();

  salesIncentiveFlag: boolean = false;
  enablementsIncentiveFlag: boolean = false;

  constructor(
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.salesIncentiveFlag = this.companyTypePreferences && this.companyTypePreferences[0]
      ? this.companyTypePreferences[0].enabled
      : false;
    this.enablementsIncentiveFlag = this.companyTypePreferences && this.companyTypePreferences[1]
      ? this.companyTypePreferences[1].enabled
      : false;
  }

  changeCompanyPreferences(companyPreferencesId: number, checked: boolean): void {
    const lang = localStorage.getItem('selectedLanguage');
    const companyParams = {
      companyId: this.userProfile.company.id,
      preferenceId: companyPreferencesId,
      enabled: checked,
    };

    if (companyPreferencesId === 1) {
      this.salesIncentiveFlag = checked;
    }
    if (companyPreferencesId === 2) {
      this.enablementsIncentiveFlag = checked;
    }

    this.managerService.postCompanyPreferences(companyParams).subscribe(
      (data) => {
        let msg = 'Company preference updated successfully.';
        if (lang === 'Korean') {
          msg = '회사 환경 설정이 성공적으로 업데이트되었습니다.';
        }
        if (lang === 'Japanese') {
          msg = '会社の設定が正常に更新されました。';
        }
        this.popupMessageService.showSuccess(
          msg,
          'success',
          'salesChallengeToggleForm'
        );
        if (companyPreferencesId === 1 || companyPreferencesId === 2) {
          this.storeService.isTabActivated.next(true);
        }
        this.preferenceChanged.emit();
      },
      (err) => {
        console.error('Error updating preference:', err);
      }
    );
  }
}
